import React from 'react'
import { Link } from 'react-router-dom'
import SeoMeta from '../Common/SeoMeta'

const Sitemap = () => {
    return (
        <>
            <SeoMeta
                title="HTML Sitemap | European Exotic Center"
                description="HTML sitemap for European Exotic Center."
                keywords=""
                ogTitle="HTML Sitemap | European Exotic Center"
                ogDescription="HTML sitemap for European Exotic Center."
            />
            <section className='cm-main-wrap'>
                <div className='container'>
                    <ul class="sitemap">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <Link to="/cars-for-sale-florida-california">Inventory</Link>
                        </li>
                        <li>
                            <Link to="/sell-my-vehicle">Sell Us Your Car</Link>
                        </li>
                        <li>
                            <Link to="/finance">Finance</Link>
                        </li>
                        <li className='has-child'>
                            <Link to="/car-service-in-tampa-fl">Service</Link>
                            <ul>
                                <li>
                                    <Link to="/car-service-in-tampa-fl">Our Services</Link>
                                </li>
                                {/* <li>
                                    <Link to="/schedule-car-maintenance-or-auto-repair-tampa-fl">Schedule Service</Link>
                                </li> */}
                                
                                <li><Link to='/ferrari-repair'>Ferrari Service</Link></li>
                                <li><Link to='/lamborghini-repair'>Lamborghini Service</Link></li>
                                <li><Link to='/porsche-repair'>Porsche Service</Link></li>
                                <li><Link to='/aston-martin-repair'>Aston Martin Service</Link></li>
                                <li><Link to='/mclaren-repair'>McLaren Service</Link></li>
                                <li><Link to='/classic-car-repair'>Classic Car Service</Link></li>
                                <li><Link to='/audi-r8-repair'>Audi R8 Service</Link></li>
                            </ul>
                        </li>
                        <li>
                            <Link to="/detailing">Detail</Link>
                        </li>
                        <li className='has-child'>
                            <Link to="/about-european-exotic-center">About Us</Link>
                            <ul>
                                <li>
                                    <Link to="/european-exotic-center-customer-reviews">Company Reviews</Link>
                                </li>
                                <li>
                                    <Link to="/consign-your-car">Consign</Link>
                                </li>
                                <li>
                                    <Link to="/car-finder">Car Finder</Link>
                                </li>
                                <li>
                                    <Link to="/automotive-jobs">Careers</Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link to="/we-buy-exotics">We Buy Exotics</Link>
                        </li>
                        <li>
                            <Link to="/privacy">Privacy</Link>
                        </li>
                    </ul>
                </div>
            </section>
        </>
    )
}

export default Sitemap